import { motion } from 'framer-motion';

import { INavLink } from '../../navigation-meta';
import { SideMenuItem } from '../side-menu-item';

export interface ISubMenuListProps {
  currentPath: string;
  isActive: boolean;
  navPos: number;
  subNavItems: INavLink[];
  handleClick: (path?: string, navPos?: number) => void;
}

export const SubMenuList = ({
  subNavItems,
  navPos,
  isActive,
  currentPath,
  handleClick,
}: ISubMenuListProps) => (
  <motion.div
    animate={isActive ? 'open' : 'closed'}
    variants={{
      open: { opacity: 1, x: 0 },
      closed: { opacity: 0, x: '-5%' },
    }}
    transition={{ type: 'spring', restSpeed: 0.1 }}
  >
    {subNavItems.map((item: INavLink) => (
      <SideMenuItem
        key={item.name}
        link={item}
        navPos={navPos}
        isNested
        currentPath={currentPath}
        handleNavClick={handleClick}
      />
    ))}
  </motion.div>
);
